import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { i18n } from '@/i18n';

// store
import {
  useLoading,
  useInfo,
  useComic,
} from '@/store';
import FloatText from '@/components/composed/FloatText/index.vue';
import ToastBlock from '@/components/composed/ToastBlock.vue';
import Loading from '@/components/basic/Loading.vue';
import ComicReader from '@/components/anniversary/ComicReader.vue';
import TheModal from '@/components/TheModal.vue';
import TheNotification from '@/components/TheNotification.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import TheFooter from '@/components/TheFooter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { setLocaleMessage } = useI18n();
const { getInfo } = useInfo();
const { isLoading } = storeToRefs(useLoading());
const { lang, translations } = storeToRefs(useInfo());
const { showComicReader } = storeToRefs(useComic());

const isInitialized = ref(false);

(async () => {
  await getInfo();
  if (lang.value && translations.value) {
    i18n.global.locale = lang.value;
    setLocaleMessage(lang.value, translations.value);
  }
  isInitialized.value = true;
})();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheNavbar),
    _createVNode(TheNotification),
    (isInitialized.value)
      ? (_openBlock(), _createElementBlock("main", {
          key: 0,
          class: _normalizeClass(['main', { freeze: _unref(showComicReader) }])
        }, [
          _createVNode(_component_router_view)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(showComicReader))
      ? (_openBlock(), _createBlock(ComicReader, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(TheModal),
    _createVNode(TheFooter),
    _createVNode(FloatText),
    _createVNode(ToastBlock),
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})